<template>
  <NotificationTemplate :notification="notification">
    <template #pic>
      <div class="label-pic is-review">
        <icon
          data="@icon/todo-review.svg"
          class="label-pic__icon"
          :fill="true"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <a
          class="link is-large"
          target="_blank"
          :href="notification.todoUrl"
        >
          {{ title }}
        </a>
        <template v-if="notification.initiatorFullName">
          by
          <span class="notification__update-item__initiator">
            {{ notification.initiatorFullName }}
          </span>
        </template>
      </BaseSubHeading>
    </template>
    <template #content>
      <div class="notification__todo-review-item">
        <a
          v-if="notification.itemNumber"
          class="link"
          target="_blank"
          :href="notification.itemUrl"
        >
          {{ notification.itemNumber }}
        </a>
        <div
          v-if="notification.item?.label"
          class="custom-label is-preview"
        >
          <LabelPreviewText :label="notification.item.label" />
        </div>
        <span>{{ notification.itemTitle }}</span>
      </div>
    </template>
  </NotificationTemplate>
</template>

<script setup lang="ts">
import { computed } from "vue"

import LabelPreviewText from "@/components/Label/LabelPreviewText.vue"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationType } from "@/models/Notification/common"
import { NotificationTodo } from "@/models/Notification/NotificationTodo"

const props = defineProps<{
  notification: NotificationTodo
}>()

const isPmReview = computed(
  () =>
    props.notification.reviewRequestActivityType === "PM" ||
    props.notification.type === NotificationType.TODO_PM_REVIEW_REQUEST
)
const title = computed(() => (isPmReview.value ? "PM Review Request" : "Client Review Request"))
</script>
